module.exports = __webpack_public_path__ + "img/new-car.6b6de14a.png";